/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs'
import * as FeedDefs from '../feed/defs.defs'
import * as GraphDefs from '../graph/defs.defs'

const $nsid = 'app.bsky.notification.getGroupedNotifications'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  feed: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.string<{
        maxLength: 32
        knownValues: [
          'all',
          'people-i-follow',
          'conversations',
          'followers',
          'activity',
        ]
      }>({ maxLength: 32 }),
      'all',
    ),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 50, minimum: 1 }),
      30,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 1024 })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 1024 })),
  groups: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Group>((() => group) as any),
  ),
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  relatedViews: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ActorDefs.ProfileViewBasic>(
            (() => ActorDefs.profileViewBasic) as any,
          ),
          /*#__PURE__*/ l.typedRef<FeedDefs.BlockedPost>(
            (() => FeedDefs.blockedPost) as any,
          ),
          /*#__PURE__*/ l.typedRef<FeedDefs.GeneratorView>(
            (() => FeedDefs.generatorView) as any,
          ),
          /*#__PURE__*/ l.typedRef<FeedDefs.NotFoundPost>(
            (() => FeedDefs.notFoundPost) as any,
          ),
          /*#__PURE__*/ l.typedRef<FeedDefs.PostView>(
            (() => FeedDefs.postView) as any,
          ),
          /*#__PURE__*/ l.typedRef<GraphDefs.StarterPackViewBasic>(
            (() => GraphDefs.starterPackViewBasic) as any,
          ),
        ],
        false,
      ),
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** [UNSTABLE - DO NOT USE THIS ENDPOINT WHILE THIS NOTE IS HERE] Enumerate notifications for the requesting account, pre-grouped for rendering. Supersedes listNotifications. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Contains common metadata and kind-specific data for a notification group or individual notification. */
type Group = {
  $type?: 'app.bsky.notification.getGroupedNotifications#group'
  id: string
  kind:
    | l.$Typed<LikeGroup>
    | l.$Typed<MultiPostLikeGroup>
    | l.$Typed<MultiPostRepostGroup>
    | l.$Typed<MultiPostLikeViaRepostGroup>
    | l.$Typed<MultiPostRepostViaRepostGroup>
    | l.$Typed<RepostGroup>
    | l.$Typed<LikeViaRepostGroup>
    | l.$Typed<RepostViaRepostGroup>
    | l.$Typed<FollowGroup>
    | l.$Typed<SubscribedPostGroup>
    | l.$Typed<GeneratorLikeGroup>
    | l.$Typed<ReplyNotification>
    | l.$Typed<QuoteNotification>
    | l.$Typed<MentionNotification>
    | l.$Typed<FollowBackNotification>
    | l.$Typed<VerifiedNotification>
    | l.$Typed<UnverifiedNotification>
    | l.$Typed<StarterPackJoinedNotification>
    | l.$Typed<ContactMatchNotification>
    | l.Unknown$TypedObject
  count: number
  isRead: boolean
  indexedAt: l.DatetimeString
}

export type { Group }

/** Contains common metadata and kind-specific data for a notification group or individual notification. */
const group = /*#__PURE__*/ l.typedObject<Group>(
  $nsid,
  'group',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string({ maxLength: 256 }),
    kind: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<LikeGroup>((() => likeGroup) as any),
        /*#__PURE__*/ l.typedRef<MultiPostLikeGroup>(
          (() => multiPostLikeGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<MultiPostRepostGroup>(
          (() => multiPostRepostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<MultiPostLikeViaRepostGroup>(
          (() => multiPostLikeViaRepostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<MultiPostRepostViaRepostGroup>(
          (() => multiPostRepostViaRepostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepostGroup>((() => repostGroup) as any),
        /*#__PURE__*/ l.typedRef<LikeViaRepostGroup>(
          (() => likeViaRepostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<RepostViaRepostGroup>(
          (() => repostViaRepostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<FollowGroup>((() => followGroup) as any),
        /*#__PURE__*/ l.typedRef<SubscribedPostGroup>(
          (() => subscribedPostGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<GeneratorLikeGroup>(
          (() => generatorLikeGroup) as any,
        ),
        /*#__PURE__*/ l.typedRef<ReplyNotification>(
          (() => replyNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<QuoteNotification>(
          (() => quoteNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<MentionNotification>(
          (() => mentionNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<FollowBackNotification>(
          (() => followBackNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<VerifiedNotification>(
          (() => verifiedNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<UnverifiedNotification>(
          (() => unverifiedNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<StarterPackJoinedNotification>(
          (() => starterPackJoinedNotification) as any,
        ),
        /*#__PURE__*/ l.typedRef<ContactMatchNotification>(
          (() => contactMatchNotification) as any,
        ),
      ],
      false,
    ),
    count: /*#__PURE__*/ l.integer({ minimum: 1 }),
    isRead: /*#__PURE__*/ l.boolean(),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { group }

/** One actor who liked the group's post. */
type LikeItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#likeItem'
  actor: l.DidString
}

export type { LikeItem }

/** One actor who liked the group's post. */
const likeItem = /*#__PURE__*/ l.typedObject<LikeItem>(
  $nsid,
  'likeItem',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { likeItem }

/** Group of likes by different actors on the same post. */
type LikeGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#likeGroup'
  post: l.AtUriString
  items: LikeItem[]
}

export type { LikeGroup }

/** Group of likes by different actors on the same post. */
const likeGroup = /*#__PURE__*/ l.typedObject<LikeGroup>(
  $nsid,
  'likeGroup',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LikeItem>((() => likeItem) as any),
      { minLength: 1 },
    ),
  }),
)

export { likeGroup }

/** An actor who followed the requesting account, possibly via a starter pack. */
type FollowItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#followItem'
  actor: l.DidString
  starterPack?: l.AtUriString
}

export type { FollowItem }

/** An actor who followed the requesting account, possibly via a starter pack. */
const followItem = /*#__PURE__*/ l.typedObject<FollowItem>(
  $nsid,
  'followItem',
  /*#__PURE__*/ l.object({
    actor: /*#__PURE__*/ l.string({ format: 'did' }),
    starterPack: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { followItem }

/** One actor who reposted the group's post. */
type RepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#repostItem'
  actor: l.DidString
}

export type { RepostItem }

/** One actor who reposted the group's post. */
const repostItem = /*#__PURE__*/ l.typedObject<RepostItem>(
  $nsid,
  'repostItem',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repostItem }

/** Group of actors who followed the requesting account. */
type FollowGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#followGroup'
  items: FollowItem[]
}

export type { FollowGroup }

/** Group of actors who followed the requesting account. */
const followGroup = /*#__PURE__*/ l.typedObject<FollowGroup>(
  $nsid,
  'followGroup',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<FollowItem>((() => followItem) as any),
      { minLength: 1 },
    ),
  }),
)

export { followGroup }

/** Group of reposts by different actors of the same post. */
type RepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#repostGroup'
  post: l.AtUriString
  items: RepostItem[]
}

export type { RepostGroup }

/** Group of reposts by different actors of the same post. */
const repostGroup = /*#__PURE__*/ l.typedObject<RepostGroup>(
  $nsid,
  'repostGroup',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepostItem>((() => repostItem) as any),
      { minLength: 1 },
    ),
  }),
)

export { repostGroup }

/** One actor who liked the feed generator in the group. */
type GeneratorLikeItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#generatorLikeItem'
  actor: l.DidString
}

export type { GeneratorLikeItem }

/** One actor who liked the feed generator in the group. */
const generatorLikeItem = /*#__PURE__*/ l.typedObject<GeneratorLikeItem>(
  $nsid,
  'generatorLikeItem',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { generatorLikeItem }

/** One actor who liked the group's post via the requesting account's repost. */
type LikeViaRepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#likeViaRepostItem'
  actor: l.DidString
}

export type { LikeViaRepostItem }

/** One actor who liked the group's post via the requesting account's repost. */
const likeViaRepostItem = /*#__PURE__*/ l.typedObject<LikeViaRepostItem>(
  $nsid,
  'likeViaRepostItem',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { likeViaRepostItem }

/** One post which was liked by the group's actor. */
type MultiPostLikeItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostLikeItem'
  post: l.AtUriString
}

export type { MultiPostLikeItem }

/** One post which was liked by the group's actor. */
const multiPostLikeItem = /*#__PURE__*/ l.typedObject<MultiPostLikeItem>(
  $nsid,
  'multiPostLikeItem',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { multiPostLikeItem }

/** A post quoting a post by the requesting account. */
type QuoteNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#quoteNotification'
  post: l.AtUriString
  parent?: l.AtUriString
}

export type { QuoteNotification }

/** A post quoting a post by the requesting account. */
const quoteNotification = /*#__PURE__*/ l.typedObject<QuoteNotification>(
  $nsid,
  'quoteNotification',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    parent: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { quoteNotification }

/** A reply to a post by the requesting account or to a thread they are participating in. */
type ReplyNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#replyNotification'
  post: l.AtUriString
  parent: l.AtUriString
}

export type { ReplyNotification }

/** A reply to a post by the requesting account or to a thread they are participating in. */
const replyNotification = /*#__PURE__*/ l.typedObject<ReplyNotification>(
  $nsid,
  'replyNotification',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    parent: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { replyNotification }

/** Group of likes by different actors on the same feed generator. */
type GeneratorLikeGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#generatorLikeGroup'
  items: GeneratorLikeItem[]
  generator: l.AtUriString
}

export type { GeneratorLikeGroup }

/** Group of likes by different actors on the same feed generator. */
const generatorLikeGroup = /*#__PURE__*/ l.typedObject<GeneratorLikeGroup>(
  $nsid,
  'generatorLikeGroup',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<GeneratorLikeItem>((() => generatorLikeItem) as any),
      { minLength: 1 },
    ),
    generator: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { generatorLikeGroup }

/** Group of likes by different actors on the same post via the requesting account's repost. */
type LikeViaRepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#likeViaRepostGroup'
  post: l.AtUriString
  items: LikeViaRepostItem[]
  viaRepost: l.AtUriString
}

export type { LikeViaRepostGroup }

/** Group of likes by different actors on the same post via the requesting account's repost. */
const likeViaRepostGroup = /*#__PURE__*/ l.typedObject<LikeViaRepostGroup>(
  $nsid,
  'likeViaRepostGroup',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<LikeViaRepostItem>((() => likeViaRepostItem) as any),
      { minLength: 1 },
    ),
    viaRepost: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { likeViaRepostGroup }

/** Group of likes by the same actor on different posts. */
type MultiPostLikeGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostLikeGroup'
  actor: l.DidString
  items: MultiPostLikeItem[]
}

export type { MultiPostLikeGroup }

/** Group of likes by the same actor on different posts. */
const multiPostLikeGroup = /*#__PURE__*/ l.typedObject<MultiPostLikeGroup>(
  $nsid,
  'multiPostLikeGroup',
  /*#__PURE__*/ l.object({
    actor: /*#__PURE__*/ l.string({ format: 'did' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<MultiPostLikeItem>((() => multiPostLikeItem) as any),
      { minLength: 2 },
    ),
  }),
)

export { multiPostLikeGroup }

/** One new post by an actor the requesting account subscribes to. */
type SubscribedPostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#subscribedPostItem'
  post: l.AtUriString
  actor: l.DidString

  /**
   * The post this one replies to, if it is a reply.
   */
  parent?: l.AtUriString
}

export type { SubscribedPostItem }

/** One new post by an actor the requesting account subscribes to. */
const subscribedPostItem = /*#__PURE__*/ l.typedObject<SubscribedPostItem>(
  $nsid,
  'subscribedPostItem',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    actor: /*#__PURE__*/ l.string({ format: 'did' }),
    parent: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { subscribedPostItem }

/** A post mentioning the requesting account. */
type MentionNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#mentionNotification'
  post: l.AtUriString
  parent?: l.AtUriString
}

export type { MentionNotification }

/** A post mentioning the requesting account. */
const mentionNotification = /*#__PURE__*/ l.typedObject<MentionNotification>(
  $nsid,
  'mentionNotification',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    parent: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { mentionNotification }

/** One post which was reposted by the group's actor. */
type MultiPostRepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostRepostItem'
  post: l.AtUriString
}

export type { MultiPostRepostItem }

/** One post which was reposted by the group's actor. */
const multiPostRepostItem = /*#__PURE__*/ l.typedObject<MultiPostRepostItem>(
  $nsid,
  'multiPostRepostItem',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { multiPostRepostItem }

/** One actor who reposted the group's post via the requesting account's repost. */
type RepostViaRepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#repostViaRepostItem'
  actor: l.DidString
}

export type { RepostViaRepostItem }

/** One actor who reposted the group's post via the requesting account's repost. */
const repostViaRepostItem = /*#__PURE__*/ l.typedObject<RepostViaRepostItem>(
  $nsid,
  'repostViaRepostItem',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repostViaRepostItem }

/** Group of new posts by actors the requesting account subscribes to. */
type SubscribedPostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#subscribedPostGroup'
  items: SubscribedPostItem[]
}

export type { SubscribedPostGroup }

/** Group of new posts by actors the requesting account subscribes to. */
const subscribedPostGroup = /*#__PURE__*/ l.typedObject<SubscribedPostGroup>(
  $nsid,
  'subscribedPostGroup',
  /*#__PURE__*/ l.object({
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<SubscribedPostItem>(
        (() => subscribedPostItem) as any,
      ),
      { minLength: 1 },
    ),
  }),
)

export { subscribedPostGroup }

/** Group of reposts by the same actor of different posts. */
type MultiPostRepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostRepostGroup'
  actor: l.DidString
  items: MultiPostRepostItem[]
}

export type { MultiPostRepostGroup }

/** Group of reposts by the same actor of different posts. */
const multiPostRepostGroup = /*#__PURE__*/ l.typedObject<MultiPostRepostGroup>(
  $nsid,
  'multiPostRepostGroup',
  /*#__PURE__*/ l.object({
    actor: /*#__PURE__*/ l.string({ format: 'did' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<MultiPostRepostItem>(
        (() => multiPostRepostItem) as any,
      ),
      { minLength: 2 },
    ),
  }),
)

export { multiPostRepostGroup }

/** Group of reposts by different actors of the same post via the requesting account's repost. */
type RepostViaRepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#repostViaRepostGroup'
  post: l.AtUriString
  items: RepostViaRepostItem[]
  viaRepost: l.AtUriString
}

export type { RepostViaRepostGroup }

/** Group of reposts by different actors of the same post via the requesting account's repost. */
const repostViaRepostGroup = /*#__PURE__*/ l.typedObject<RepostViaRepostGroup>(
  $nsid,
  'repostViaRepostGroup',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    items: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<RepostViaRepostItem>(
        (() => repostViaRepostItem) as any,
      ),
      { minLength: 1 },
    ),
    viaRepost: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { repostViaRepostGroup }

/** An actor verified the requesting account. */
type VerifiedNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#verifiedNotification'
  actor: l.DidString
}

export type { VerifiedNotification }

/** An actor verified the requesting account. */
const verifiedNotification = /*#__PURE__*/ l.typedObject<VerifiedNotification>(
  $nsid,
  'verifiedNotification',
  /*#__PURE__*/ l.object({ actor: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { verifiedNotification }

/** An actor followed the requesting account back, possibly via a starter pack. */
type FollowBackNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#followBackNotification'
  actor: l.DidString
  starterPack?: l.AtUriString
}

export type { FollowBackNotification }

/** An actor followed the requesting account back, possibly via a starter pack. */
const followBackNotification =
  /*#__PURE__*/ l.typedObject<FollowBackNotification>(
    $nsid,
    'followBackNotification',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
      starterPack: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string({ format: 'at-uri' }),
      ),
    }),
  )

export { followBackNotification }

/** A verification of the requesting account was removed. */
type UnverifiedNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#unverifiedNotification'
  actor: l.DidString
}

export type { UnverifiedNotification }

/** A verification of the requesting account was removed. */
const unverifiedNotification =
  /*#__PURE__*/ l.typedObject<UnverifiedNotification>(
    $nsid,
    'unverifiedNotification',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { unverifiedNotification }

/** A contact of the requesting account joined Bluesky. */
type ContactMatchNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#contactMatchNotification'
  actor: l.DidString
}

export type { ContactMatchNotification }

/** A contact of the requesting account joined Bluesky. */
const contactMatchNotification =
  /*#__PURE__*/ l.typedObject<ContactMatchNotification>(
    $nsid,
    'contactMatchNotification',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
    }),
  )

export { contactMatchNotification }

/** One post which was liked by the group's actor via the requesting account's repost. */
type MultiPostLikeViaRepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostLikeViaRepostItem'
  post: l.AtUriString
  viaRepost: l.AtUriString
}

export type { MultiPostLikeViaRepostItem }

/** One post which was liked by the group's actor via the requesting account's repost. */
const multiPostLikeViaRepostItem =
  /*#__PURE__*/ l.typedObject<MultiPostLikeViaRepostItem>(
    $nsid,
    'multiPostLikeViaRepostItem',
    /*#__PURE__*/ l.object({
      post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
      viaRepost: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    }),
  )

export { multiPostLikeViaRepostItem }

/** Group of likes by the same actor on different posts via the requesting account's reposts. */
type MultiPostLikeViaRepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostLikeViaRepostGroup'
  actor: l.DidString
  items: MultiPostLikeViaRepostItem[]
}

export type { MultiPostLikeViaRepostGroup }

/** Group of likes by the same actor on different posts via the requesting account's reposts. */
const multiPostLikeViaRepostGroup =
  /*#__PURE__*/ l.typedObject<MultiPostLikeViaRepostGroup>(
    $nsid,
    'multiPostLikeViaRepostGroup',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
      items: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<MultiPostLikeViaRepostItem>(
          (() => multiPostLikeViaRepostItem) as any,
        ),
        { minLength: 2 },
      ),
    }),
  )

export { multiPostLikeViaRepostGroup }

/** One post which was reposted by the group's actor via the requesting account's repost. */
type MultiPostRepostViaRepostItem = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostRepostViaRepostItem'
  post: l.AtUriString
  viaRepost: l.AtUriString
}

export type { MultiPostRepostViaRepostItem }

/** One post which was reposted by the group's actor via the requesting account's repost. */
const multiPostRepostViaRepostItem =
  /*#__PURE__*/ l.typedObject<MultiPostRepostViaRepostItem>(
    $nsid,
    'multiPostRepostViaRepostItem',
    /*#__PURE__*/ l.object({
      post: /*#__PURE__*/ l.string({ format: 'at-uri' }),
      viaRepost: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    }),
  )

export { multiPostRepostViaRepostItem }

/** Group of reposts by the same actor of different posts via the requesting account's reposts. */
type MultiPostRepostViaRepostGroup = {
  $type?: 'app.bsky.notification.getGroupedNotifications#multiPostRepostViaRepostGroup'
  actor: l.DidString
  items: MultiPostRepostViaRepostItem[]
}

export type { MultiPostRepostViaRepostGroup }

/** Group of reposts by the same actor of different posts via the requesting account's reposts. */
const multiPostRepostViaRepostGroup =
  /*#__PURE__*/ l.typedObject<MultiPostRepostViaRepostGroup>(
    $nsid,
    'multiPostRepostViaRepostGroup',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
      items: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<MultiPostRepostViaRepostItem>(
          (() => multiPostRepostViaRepostItem) as any,
        ),
        { minLength: 2 },
      ),
    }),
  )

export { multiPostRepostViaRepostGroup }

/** An actor joined Bluesky via a starter pack created by the requesting account. */
type StarterPackJoinedNotification = {
  $type?: 'app.bsky.notification.getGroupedNotifications#starterPackJoinedNotification'
  actor: l.DidString
  starterPack: l.AtUriString
}

export type { StarterPackJoinedNotification }

/** An actor joined Bluesky via a starter pack created by the requesting account. */
const starterPackJoinedNotification =
  /*#__PURE__*/ l.typedObject<StarterPackJoinedNotification>(
    $nsid,
    'starterPackJoinedNotification',
    /*#__PURE__*/ l.object({
      actor: /*#__PURE__*/ l.string({ format: 'did' }),
      starterPack: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    }),
  )

export { starterPackJoinedNotification }
